import React, { useContext, useEffect, useState, Suspense, lazy } from "react";
import { PropTypes } from "prop-types";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { BrowserRouter } from "react-router-dom/cjs/react-router-dom.min";
import jwtDecode from "jwt-decode";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { useIdleTimer } from "react-idle-timer";

// Import context and utilities
import MainState from "../../Services/Context/MainState";
import MainContext from "../../Services/Context/MainContext";
import { userLogout } from "../../Services/UserUtil";
import Services from "../../Services/Services";
import keycloakData from "../../api/apps/keycloakData";
import { API_BASE_URL } from "../../api/apps/baseUrls";
import axios from "axios";

// Import theme wrapper
import ThemeWrapper from "./ThemeWrapper";

// Lazy load components
const NotFound = lazy(() => import("containers/Pages/Standalone/NotFoundDedicated"));
const Auth = lazy(() => import("./Auth"));
const Index = lazy(() => import("../LandingPage/Index"));
const HomeNew = lazy(() => import("../LandingPage/HomeNew"));
const IndexHome = lazy(() => import("../LandingPage/IndexHome"));
const ServResources = lazy(() => import("../LandingPage/ServResources"));
const About = lazy(() => import("../LandingPage/About"));
const MainContact = lazy(() => import("../LandingPage/MainContact"));
const Login = lazy(() => import("/app/containers/Forms/Login"));
const RaiseIssue = lazy(() => import("../Templates/Components/RaiseIssueForm/RaiseIssue"));
const InstituteIndex = lazy(() => import("/app/containers/Institute/InsituteIndex"));
const SpokesInstitutes = lazy(() => import("../LandingPage/SpokesInstitutes"));
const Authenticated = lazy(() => import("../NotFound/Authenticated"));
const RegistrationPage = lazy(() => import("../Forms/RegistrationPage"));
const AdminApplication = lazy(() => import("./AdminApplication"));
const UserApplication = lazy(() => import("./UserApplication"));
const PmuApplication = lazy(() => import("./PmuApplication"));
const IcApplication = lazy(() => import("./IcApplication"));
const SuperAdminApplication = lazy(() => import("./SuperAdminApplication"));
const MeityAppplication = lazy(() => import("./MeityAppplication"));
const ConferenceHomepage = lazy(() => import("../pageListAsync").then(module => ({ default: module.ConferenceHomepage })));
const ConferenceHomeDetailsPage = lazy(() => import("../pageListAsync").then(module => ({ default: module.ConferenceHomeDetailsPage })));
const ThematicClusters = lazy(() => import("../LandingPage/ThematicClusters"));
const ThematicClustersInstitutes = lazy(() => import("../LandingPage/ThematicClustersInstitutes"));
const ViewAllNewsHome = lazy(() => import("../LandingPage/ViewAllNewsHome"));
const ViewSingleNews = lazy(() => import("../LandingPage/ViewSingleNews"));
const ViewAllArticleHome = lazy(() => import("../LandingPage/ViewAllArticleHome"));
const ViewAllEventsHome = lazy(() => import("../LandingPage/Events/ViewAllEventsHome"));

// Loading component
const LoadingFallback = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

// Load dotenv
// import dotenv from "dotenv";
// dotenv.config();

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

// function App(props) {
const App = (props) => {
  const { history } = props;
  // const [getRole, setRole] = useState();
  const details = useContext(MainContext);

  const cookiesToken = Cookies.get("ac_token");
  const userRole = localStorage.getItem("Role");
  const USERSERVICE_BASE_URL = API_BASE_URL;

  // axios.interceptors.request.use(
  //   function (config) {
  //     if (config.method.toUpperCase() === "OPTIONS") {
  //       console.log("OPTIONS method is not allowed");
  //       return Promise.reject(new Error("OPTIONS method is not allowed"));
  //     }

  //     const isKeycloakCodeGen = config.url.includes(
  //       USERSERVICE_BASE_URL + "/codegen"
  //     );
  //     // if (!isKeycloakCodeGen) {
  //     //   console.log("called");
  //     //   config.headers.Authorization = "Bearer " + Cookies.get("ac_token");
  //     // }

  //     return config;
  //   },
  //   function (error) {
  //     return Promise.reject(error);
  //   }
  // );

  // axios.interceptors.request.use(
  //   function (config) {
  //     const originalMethod = config.method.toUpperCase();

  //     if (originalMethod === "OPTIONS") {
  //       console.log("OPTIONS method is not allowed");
  //       return Promise.reject(new Error("OPTIONS method is not allowed"));
  //     }

  //     const isKeycloakCodeGen = config.url.includes(
  //       USERSERVICE_BASE_URL + "/tokengen"
  //     );

  //     const isShowProfile = config.url.includes(
  //       USERSERVICE_BASE_URL + "/showprofile"
  //     );
  //     const isUpdateProfile = config.url.includes(
  //       USERSERVICE_BASE_URL + "/updateprofile"
  //     );

  //     if (isKeycloakCodeGen) {
  //       console.log("Request to keyCloak_codeGen is allowed");
  //     }
  //     if (!isShowProfile && !isUpdateProfile) {
  //       console.log("Authorization header added");
  //       config.headers.Authorization = "Bearer " + Cookies.get("ac_token");
  //     } else {
  //       console.log("ele");
  //     }
  //     console.log("elese");

  //     config.originalMethod = originalMethod;

  //     return config;
  //   },
  //   function (error) {
  //     return Promise.reject(error);
  //   }
  // );

  // ---------------------

  axios.interceptors.request.use(
    function (config) {
      const originalMethod = config.method.toUpperCase();

      if (originalMethod === "OPTIONS") {
        // console.log("OPTIONS method is not allowed");
        return Promise.reject(new Error("OPTIONS method is not allowed"));
      }

      const isKeycloakCodeGen = config.url.includes(
        USERSERVICE_BASE_URL + "/tokengen"
      );

      if (isKeycloakCodeGen) {
        console.log("isKeycloakCodeGen", !isKeycloakCodeGen, isKeycloakCodeGen);
        // console.log("Request to keyCloak_codeGen is allowed");
      } else {
        console.log("Authorization header added");
        // config.headers.Authorization = "Bearer " + Cookies.get("ac_token");
      }

      config.originalMethod = originalMethod;

      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  // axios.interceptors.request.use(
  //   function (config) {
  //     const isShowProfile = config.url.includes(
  //       USERSERVICE_BASE_URL + "/showprofile",
  //       bodyjson
  //     );
  //     const isUpdateProfile = config.url.includes(
  //       USERSERVICE_BASE_URL + "/updateprofile",
  //       bodyjson
  //     );

  //     if (!isShowProfile && !isUpdateProfile) {
  //       console.log("called");
  //       config.headers.Authorization = "Bearer " + Cookies.get("ac_token");
  //     } else {
  //       console.log("else called");
  //     }
  //     console.log("out called");

  //     return config;
  //   },
  //   function (error) {
  //     return Promise.reject(error);
  //   }
  // );

  const secureFlag =
    window.location.protocol === "https:"
      ? { secure: true, sameSite: "strict" }
      : { secure: false, sameSite: "lax" };
  // useEffect(() => {
  //   const lastLoginTime = localStorage.getItem("LoginTime");

  //   if (lastLoginTime) {
  //     const minutesSinceLastLogin = (Date.now() - lastLoginTime) / 1000 / 60;
  //     if (minutesSinceLastLogin < 1440 && minutesSinceLastLogin >= 30) {
  //       Swal.fire({
  //         title: "Warning",
  //         text: `Login session has expired`,
  //         icon: "info",
  //       }).then(function () {
  //         Cookies.remove("ac_token");
  //         Cookies.remove("refToken");
  //         localStorage.clear();
  //         userLogout();
  //         window.location.href = "/";
  //       });
  //     } else if (minutesSinceLastLogin >= 30) {
  //       Cookies.remove("ac_token");
  //       Cookies.remove("refToken");
  //       localStorage.clear();
  //       window.location.href = "/";
  //     }
  //   }
  // }, []);

  // useEffect(() => {
  //   const cookiesTokenValue = Cookies.get("ac_token");
  //   if (cookiesTokenValue) {
  //     const decodeToken = jwtDecode(cookiesTokenValue);
  //     const token_expireTime = decodeToken.exp;
  //     const current_time = Math.floor(Date.now() / 1000);
  //     if (decodeToken) {
  //       if (current_time >= token_expireTime) {
  //         Swal.fire({
  //           title: "Warning",
  //           text: `Login session has expired`,
  //           icon: "info",
  //         }).then(function () {
  //           userLogout();
  //           Cookies.remove("ac_token");
  //           Cookies.remove("refToken");
  //           localStorage.clear();
  //           window.location.href = "/";
  //         });
  //       }
  //     }
  //   }
  // }, []);

  useEffect(() => {
    const validateAccessToken = async () => {
      const cookiesTokenValue = Cookies.get("ac_token");
      const cookiesRefToken = Cookies.get("refToken");

      if (cookiesTokenValue) {
        const decodeToken = jwtDecode(cookiesTokenValue);
        const token_expireTime = decodeToken.exp;
        const current_time = Math.floor(Date.now() / 1000);
        if (decodeToken) {
          if (current_time >= token_expireTime) {
            const refreshToken = Cookies.get("refToken");
            const clientID = keycloakData.ivp_clientID;
            const bodyjson = {
              refresh_token: refreshToken,
            };
            try {
              const response =
                await Services.validateAccessTokengenByRefreshToken(
                  bodyjson,
                  clientID
                );
              if (response.status === 200) {
                // console.log("reres", response);
                const newAccessToken = response.data.data.access_token;
                let refreshToken = response.data.data.refresh_token;
                // console.log("ref act", newAccessToken);
                // console.log("ref refact", refreshToken);
                Cookies.set("ac_token", newAccessToken, {
                  // expires: 1,
                  ...secureFlag,
                });
                Cookies.set("refToken", refreshToken, {
                  // expires: 1,
                  ...secureFlag,
                });
              }
            } catch (error) {
              console.error("Error refreshing access token:", error);
              userLogout();
              Cookies.remove("ac_token");
              Cookies.remove("refToken");
              localStorage.clear();
              window.location.href = "/";
              // Swal.fire({
              //   title: "Error",
              //   text:
              //     error.response?.data?.errors ||
              //     "Session has expired, Kindly login again",
              //   icon: "error",
              // }).then(function () {
              //   userLogout();
              //   Cookies.remove("ac_token");
              //   Cookies.remove("refToken");
              //   localStorage.clear();
              //   window.location.href = "/";
              // });
              return;
            }
          }
        }
      }
      if (cookiesRefToken) {
        const decodeRefToken = jwtDecode(cookiesRefToken);
        const refToken_expireTime = decodeRefToken.exp;
        const current_time = Math.floor(Date.now() / 1000);
        if (current_time >= refToken_expireTime) {
          Swal.fire({
            title: "Error",
            text:
              error.response?.data?.errors ||
              "Session has expired, Kindly login again",
            icon: "error",
          }).then(function () {
            userLogout();
            Cookies.remove("ac_token");
            Cookies.remove("refToken");
            localStorage.clear();
            window.location.href = "/";
          });
        }
      }
    };
    validateAccessToken();
  }, []);

  useEffect(() => {
    async function checkInternetLatency() {
      // const testUrl = "http://duleshwarn.hyderabad.cdac.in:3004/";
      const testUrl = USERSERVICE_BASE_URL;
      const maxLatency = 300;
      let startTime, endTime;
      console.log("maxLatency", maxLatency);

      try {
        startTime = Date.now();
        await fetch(testUrl, { method: "HEAD", cache: "no-store" });
        endTime = Date.now();

        const latency = endTime - startTime; // Calculate latency
        if (latency > maxLatency) {
          alert(
            "Your internet connection is too slow. Please check your connection."
          );
        }
      } catch (error) {
        console.error("Error checking internet speed:", error);
        alert(
          "Unable to determine internet speed. Please check your connection."
        );
      }
    }

    // Run the latency test
    // checkInternetLatency();
  }, []);

  // axios.interceptors.request.use(
  //   function (config) {
  //     const isKeycloakTokenGen = config.url.includes(
  //       USERSERVICE_BASE_URL + "/codegen",
  //       bodyjson
  //     );

  //     if (!isKeycloakTokenGen) {
  //       console.log("called");
  //       config.headers.Authorization = "Bearer " + Cookies.get("ac_token");
  //     }

  //     return config;
  //   },
  //   function (error) {
  //     return Promise.reject(error);
  //   }
  // );

  const handleOnIdle = () => {
    // console.log("User is idle");
    userLogout();
  };

  // useIdleTimer({
  //   timeout: 1000 * 60 * 2, // 5 minutes
  //   onIdle: handleOnIdle,
  //   debounce: 500,
  // });\
  // if (!!cookiesToken) {
  //   const onIdle = () => {
  //     // console.log("User is idle");
  //     userLogout();
  //   };

  const { getRemainingTime } = useIdleTimer({
    onIdle: handleOnIdle,
    timeout: 60 * 60 * 1000,
    debounce: 500,
  });
  // }
  // if (cookiesToken === null || userRole === null) {
  //   return <div>Loading...</div>;
  // }



  return (
    <ThemeWrapper>
      <MainState>
        <BrowserRouter>
          <Suspense fallback={<LoadingFallback />}>
            <Router history={history}>
              <Switch>
                <Route path="/new_service" exact component={Index} />
                <Route path="/homeold" exact component={HomeNew} />
                <Route path="/" exact component={HomeNew} />
                <Route path="/home1" exact component={IndexHome} />
                <Route path="/services_resources" exact component={ServResources} />
                <Route path="/about" exact component={About} />
                <Route path="/contact" exact component={MainContact} />
                <Route path="/login" exact component={Login} />
                <Route path="/raise-issue" exact component={RaiseIssue} />
                <Route path="/institute/:id" component={InstituteIndex} />
                <Route path="/spokesInstituteRegistration" component={SpokesInstitutes} />
                
                {cookiesToken && (
                  <Route path="/user-registration" component={Authenticated} />
                )}
                <Route path="/user-registration" component={RegistrationPage} />
                
                <Route
                  path="/administrator"
                  render={(props) => (
                    <AdminApplication
                      {...props}
                      cookiesToken={cookiesToken}
                      userRole={userRole}
                    />
                  )}
                />
                
                <Route
                  path="/user"
                  render={(props) => (
                    <UserApplication
                      {...props}
                      cookiesToken={cookiesToken}
                      userRole={userRole}
                    />
                  )}
                />
                
                <Route
                  path="/pmu"
                  render={(props) => (
                    <PmuApplication
                      {...props}
                      cookiesToken={cookiesToken}
                      userRole={userRole}
                    />
                  )}
                />
                
                <Route
                  path="/ic"
                  render={(props) => (
                    <IcApplication
                      {...props}
                      cookiesToken={cookiesToken}
                      userRole={userRole}
                    />
                  )}
                />
                
                <Route
                  path="/management"
                  render={(props) => (
                    <SuperAdminApplication
                      {...props}
                      cookiesToken={cookiesToken}
                      userRole={userRole}
                    />
                  )}
                />
                
                <Route
                  path="/meity-management"
                  render={(props) => (
                    <MeityAppplication
                      {...props}
                      cookiesToken={cookiesToken}
                      userRole={userRole}
                    />
                  )}
                />
                
                <Route exact path="/virtual-conference" component={ConferenceHomepage} />
                <Route
                  path="/virtual-conference/:eventId"
                  component={ConferenceHomeDetailsPage}
                />
                
                <Route exact path="/thematic-clusters" component={ThematicClusters} />
                <Route
                  path="/thematic-clusters/:id"
                  component={ThematicClustersInstitutes}
                />
                <Route
                  path="/institute/:instituteCode"
                  component={ThematicClustersInstitutes}
                />
                
                <Route path="/news/all" component={ViewAllNewsHome} />
                <Route path="/news/:id" component={ViewSingleNews} />
                <Route path="/article/all" component={ViewAllArticleHome} />
                <Route path="/article/:id" component={ViewSingleNews} />
                <Route path="/event/all" component={ViewAllEventsHome} />
                
                <Route component={Auth} />
                
                <Redirect to="/" />
                <Route component={NotFound} />
              </Switch>
            </Router>
          </Suspense>
        </BrowserRouter>
      </MainState>
    </ThemeWrapper>
  );
};
App.propTypes = {
  history: PropTypes.object.isRequired,
};

export default App;
